'use client';

import { NextStep } from '@/app/components/icons/NextStep';
import { cn } from '@/app/utils';

export interface Step {
  name: string;
  value: number;
}

interface ProgressBarProps {
  steps: Step[];
  currentStep: number;
  className?: string;
}

export function StepsBar({ steps, currentStep, className }: ProgressBarProps) {
  return (
    <div className={cn('flex items-center justify-center py-2', className)}>
      <div className="flex items-center">
        {steps.map((step, index) => (
          <div key={step.value} className="flex items-center">
            <div className="flex items-center">
              {/* 步骤圆点和名称 */}
              <div className="flex items-center">
                <div
                  className={cn(
                    'flex h-3.5 w-3.5 items-center justify-center rounded-full text-[10px]',
                    currentStep >= step.value ? 'bg-[#697FFF] text-white' : 'bg-system-white32 opacity-60',
                  )}
                >
                  {step.value}
                </div>
                <div
                  className={cn(
                    'ml-1 whitespace-nowrap text-sm sm:text-xs',
                    currentStep >= step.value ? 'sm:font-medium' : 'text-white opacity-60',
                  )}
                >
                  {step.name}
                </div>
              </div>

              {/* 连接线（最后一个步骤不需要连接线） */}
              {index < steps.length - 1 && (
                <NextStep
                  className={cn('mx-2 w-10', currentStep > index + 1 ? 'text-[#697FFF]' : 'text-white opacity-60')}
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
